// extracted by mini-css-extract-plugin
export default {"tabWrapper":"poolsTab_tabWrapper__c+0WK"};